var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccept(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24.7888,
    height: 24,
    rx: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1727_6220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1267 17.9771C9.97396 18.1307 9.76558 18.2165 9.54913 18.2165C9.33267 18.2165 9.1243 18.1307 8.97157 17.9771L4.35901 13.3638C3.88033 12.8851 3.88033 12.1089 4.35901 11.6311L4.93657 11.0534C5.41541 10.5747 6.19072 10.5747 6.6694 11.0534L9.54913 13.9333L17.3306 6.15171C17.8094 5.67302 18.5855 5.67302 19.0634 6.15171L19.641 6.72942C20.1196 7.2081 20.1196 7.98416 19.641 8.4621L10.1267 17.9771Z",
    fill: "#2DA771"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1727_6220"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccept);
export default __webpack_public_path__ + "static/media/accept.ef0cd889c0dd2831c60eac8f5877d6c7.svg";
export { ForwardRef as ReactComponent };